import React from 'react'
import track from './track'
import { FdContext } from './context'
import { useDeepCompareEffect } from 'ahooks'

export type RegisterInfo = {
  userId: number,
  userPhone: string,
  teamId: string,
  roleLevel: number,
  province: string,
  city: string,
  district: string,
  teamGenre: number,
  teamType: number,
  industries: string,
  memberType: string,
  teamName: string,
  platformType: string,
}

const ConfigProvider = ({ children, registerInfo }: { children: React.ReactNode, registerInfo: RegisterInfo }) => {
  useDeepCompareEffect(()=>{
    if(registerInfo.userId){
      track.registerInfo(registerInfo)
    }
  },[registerInfo])
  return <FdContext.Provider value={{}}>{children}</FdContext.Provider>
}
export default ConfigProvider